import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { CoursesService } from 'core/services/courses.service';
import { ProfileService } from 'core/services/profile.service';

export const CourseResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  coursesService: CoursesService = inject(CoursesService),
  profileService: ProfileService = inject(ProfileService)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const group = route.parent.data.group;
    const license = route.parent.data.license;
    const courseId =
      route.paramMap.get('courseId') || (group && group.customizationId) || (license && license.customizationId);
    const clientId =
      route.paramMap.get('clientId') || route.queryParamMap.get('clientId') || profileService.getFixedClientId();

    if (courseId) {
      // TODO Get course from cache when available?
      coursesService
        .getCourseDetail(courseId, clientId)
        .then((course) => resolve(course))
        .catch((err) => reject(err));
    } else {
      resolve(null);
    }
  });
};
